!<!--  -->
<template>
  <div class="">
    <div class="" style="padding:30px; background: #FFFFFF; 
    box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px; 
    border-radius: 10px;">
      <div class="" style="margin-bottom: 30px">
        <span
          style="
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #333333;
          "
        >
          轨迹推送
        </span>
      </div>
      <!-- 整柜 -->
      <div style="width: 80%">
        <div style="margin-bottom: 10px">
          <span
            style="
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #343434;
            "
            >整柜</span
          >
        </div>
        <el-collapse-transition>
          <div
            class="card1"
            :style="{ height: acIndex == 1 ? '100%' : '' }"
            @click="change(1)"
          >
            <div class="card">
              <div style="width: 20%; height: 40px">
                <el-checkbox
                  @change="switchAllChange($event, 'S')"
                  style="zoom: 130%"
                  v-model="sValue"
                ></el-checkbox>
                <span
                  style="
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #343434;
                  "
                >
                  全部
                </span>
              </div>
              <div
                v-for="(item, index) in this.listOcean"
                :key="index"
                style="width: 20%; height: 40px"
              >
                <el-checkbox
                  @change="selectChange(item.ispush, item.id, index, 'S')"
                  style="zoom: 130%"
                  v-model="item.ispush"
                ></el-checkbox>
                <span
                  style="
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #343434;
                  "
                >
                  {{ item.statusc }}
                </span>
              </div>
            </div>

            <div style="font-size: 20px; display: flex; cursor: pointer">
              <span style="color: #999; width: 35px; font-size: 13px">更多</span
              ><i style="display: inline-block" class="el-icon-arrow-down"></i>
            </div>
          </div>
        </el-collapse-transition>
      </div>
      <!-- 空运 -->
      <div style="width: 80%; margin-top: 30px">
        <div style="margin-bottom: 10px">
          <span
            style="
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #343434;
            "
            >空运</span
          >
        </div>
        <div
          class="card1"
          :style="{ height: acIndex == 2 ? '100%' : '' }"
          @click="change(2)"
        >
          <div class="card">
            <div style="width: 20%; height: 40px">
              <el-checkbox
                @change="switchAllChange($event, 'A')"
                style="zoom: 130%"
                v-model="aValue"
              ></el-checkbox>
              <span
                style="
                  font-size: 16px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #343434;
                "
              >
                全部
              </span>
            </div>
            <div
              v-for="(item, index) in this.listAir"
              :key="index"
              style="width: 20%; height: 40px"
            >
              <el-checkbox
                @change="selectChange(item.ispush, item.id, index, 'A')"
                style="zoom: 130%"
                v-model="item.ispush"
              ></el-checkbox>
              <span
                style="
                  font-size: 16px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #343434;
                "
              >
                {{ item.statusc }}
              </span>
            </div>
          </div>
          <div style="font-size: 20px; display: flex; cursor: pointer">
            <span style="color: #999; width: 35px; font-size: 13px">更多</span
            ><i style="display: inline-block" class="el-icon-arrow-down"></i>
          </div>
        </div>
      </div>

      <!-- 散货 -->
      <div style="width: 80%; margin-top: 30px">
        <div style="margin-bottom: 10px">
          <span
            style="
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #343434;
            "
            >散货</span
          >
        </div>
        <div
          class="card1"
          :style="{ height: acIndex == 3 ? '100%' : '' }"
          @click="change(3)"
        >
          <div class="card">
            <div style="width: 20%; height: 40px">
              <el-checkbox
                @change="switchAllChange($event, 'L')"
                style="zoom: 130%"
                v-model="lValue"
              ></el-checkbox>
              <span
                style="
                  font-size: 16px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #343434;
                "
              >
                全部
              </span>
            </div>
            <div
              v-for="(item, index) in this.listPacket"
              :key="index"
              style="width: 20%; height: 40px"
            >
              <el-checkbox
                @change="selectChange(item.ispush, item.id, index, 'L')"
                style="zoom: 130%"
                v-model="item.ispush"
              ></el-checkbox>
              <span
                style="
                  font-size: 16px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #343434;
                "
              >
                {{ item.statusc }}
              </span>
            </div>
          </div>
          <div style="font-size: 20px; display: flex; cursor: pointer">
            <span style="color: #999; width: 35px; font-size: 13px">更多</span
            ><i style="display: inline-block" class="el-icon-arrow-down"></i>
          </div>
        </div>
      </div>
       <!-- FBA -->
      <div style="width: 80%; margin-top: 30px">
        <div style="margin-bottom: 10px">
          <span
            style="
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #343434;
            "
            >FBA</span
          >
        </div>
        <div
          class="card1"
          :style="{ height: acIndex == 4 ? '100%' : '' }"
          @click="change(4)"
        >
          <div class="card">
            <div style="width: 20%; height: 40px">
              <el-checkbox
                @change="switchAllChange($event, 'F')"
                style="zoom: 130%"
                v-model="fValue"
              ></el-checkbox>
              <span
                style="
                  font-size: 16px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #343434;
                "
              >
                全部
              </span>
            </div>
            <div
              v-for="(item, index) in this.listFba"
              :key="index"
              style="width: 20%; height: 40px"
            >
              <el-checkbox
                @change="selectChange(item.ispush, item.id, index, 'F')"
                style="zoom: 130%"
                v-model="item.ispush"
              ></el-checkbox>
              <span
                style="
                  font-size: 16px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #343434;
                "
              >
                {{ item.statusc }}
              </span>
            </div>
          </div>
          <div style="font-size: 20px; display: flex; cursor: pointer">
            <span style="color: #999; width: 35px; font-size: 13px">更多</span
            ><i style="display: inline-block" class="el-icon-arrow-down"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据

    return {
      listOcean: [],
      listAir: [],
      listPacket: [],
      listFba: [],
      acIndex: 0,
    };
  },
  //监听属性 类似于data概念
  computed: {
    lValue() {
      let flag = true;
      this.listPacket.forEach((i) => {
        if (!i.ispush) {
          flag = false;
        }
      });
      return flag;
    },
    aValue() {
      let flag = true;
      this.listAir.forEach((i) => {
        if (!i.ispush) {
          flag = false;
        }
      });
      return flag;
    },
    sValue() {
      let flag = true;
      this.listOcean.forEach((i) => {
        if (!i.ispush) {
          flag = false;
        }
      });
      return flag;
    },
      fValue() {
      let flag = true;
      this.listFba.forEach((i) => {
        if (!i.ispush) {
          flag = false;
        }
      });
      return flag;
    },
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    switchAllChange(e, type) {
      // console.log(e)

      let ids = [];
      switch (type) {
        case "L":
          this.listPacket.forEach((i) => {
            ids.push(i.id);
          });

          break;
        case "S":
          this.listOcean.forEach((i) => {
            ids.push(i.id);
          });

          break;
        case "A":
          this.listAir.forEach((i) => {
            ids.push(i.id);
          });

          break;
          case "F":
          this.listFba.forEach((i) => {
            ids.push(i.id);
          });

          break;
        default:
          break;
      }

      this.editMessage(ids, e, type);
    },

    selectChange(e, id, index, type) {
      // console.log(index)

      switch (type) {
        case "L":
          this.listPacket[index].ispush = e;
          break;
        case "S":
          this.listOcean[index].ispush = e;
          break;
        case "A":
          this.listAir[index].ispush = e;
          break;
          case "A":
          this.listFba[index].ispush = e;
          break;
        default:
          break;
      }

      let ids = [];
      ids.push(id);

      this.editMessage(ids, e, type);
    },
    change(i) {

      if (this.acIndex == i) {
        this.acIndex = 0;
        return;
      }
      if (this.acIndex == i) {
        this.acIndex = 0;
        return;
      }
      if (this.acIndex == i) {
        this.acIndex = 0;
        return;
      }
      this.acIndex = i;
    },
    editMessage(id, ispush, type) {
      this.$http
        .post(
          "goodsTrackPushset/updateGoodsTrackPushse",
          {
            ids: id,
            ispush: ispush,
          },
          {}
        )
        .then((res) => {
          if (res.data.code != 200) {
            // 失败的情况
            this.$message.info(res.data.message);

            this.getMessageList();
            return;
          }
          this.$message.success(res.data.message);

          this.getMessageList(type);
          // this.$forceUpdate()
          // console.log(res)
        })
        .catch((res) => {
          this.$message.info(res.data.message);
          // console.log(res)
        });
    },
    getMessageList(type) {
      let user = localStorage.getItem("Authorization_lineSupplier");
      user = JSON.parse(user);

      // 修改成功后请求一个的情况
      if (type) {
        this.axios
          .get(
            "goodsTrackPushset/goodsTrackPushsetList/" +
              user.customerid +
              "/" +
              type,
            {}
          )
          .then((res) => {
            if (res.data.datas.length > 0) {
              if (type == "A") {
                this.listAir = res.data.datas;
              }
              if (type == "L") {
                this.listPacket = res.data.datas;
              }
              if (type == "S") {
                this.listOcean = res.data.datas;
              }
              if (type == "F") {
                this.listFba = res.data.datas;
              }
            } else {
              // this.getMessageList();
              this.$message.info("服务器繁忙...");
            }

            console.log("---------------getMessageListBytype-----------");
            console.log(res);
          })
          .catch((res) => {
            console.log(res);
          });
        return;
      }
  
      this.axios
        .get(
          "goodsTrackPushset/goodsTrackPushsetList/" +
            user.customerid +
            "/" +
            "A",
          {}
        )
        .then((res) => {
          if (res.data.datas.length > 0) {
            this.listAir = res.data.datas;
          } else {
            // this.getMessageList();
            this.$message.info("服务器繁忙...");
          }

          console.log("---------------getMessageList-----------");
          console.log(res);
        })
        .catch((res) => {
          console.log(res);
        });
      this.axios
        .get(
          "goodsTrackPushset/goodsTrackPushsetList/" +
            user.customerid +
            "/" +
            "L",
          {}
        )
        .then((res) => {
          if (res.data.datas.length > 0) {
            this.listPacket = res.data.datas;
          } else {
            // this.getMessageList();
            this.$message.info("服务器繁忙...");
          }

          console.log("---------------getMessageList-----------");
          console.log(res);
        })
        .catch((res) => {
          console.log(res);
        });
      this.axios
        .get(
          "goodsTrackPushset/goodsTrackPushsetList/" +
            user.customerid +
            "/" +
            "S",
          {}
        )
        .then((res) => {
          if (res.data.datas.length > 0) {
            this.listOcean = res.data.datas;
          } else {
            // this.getMessageList();
            this.$message.info("服务器繁忙...");
          }

          console.log("---------------getMessageList-----------");
          console.log(res);
        })
        .catch((res) => {
          console.log(res);
        });
         this.axios
        .get(
          "goodsTrackPushset/goodsTrackPushsetList/" +
            user.customerid +
            "/" +
            "F",
          {}
        )
        .then((res) => {
          if (res.data.datas.length > 0) {
            this.listFba = res.data.datas;
          } else {
            // this.getMessageList();
            this.$message.info("服务器繁忙...");
          }

          console.log("---------------getMessageList-----------");
          console.log(res);
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getMessageList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style   scoped>
.card1 {
  /* transition: height 1s linear; */
  height: 30px;
  display: flex;
}

.card {
  /* background-color: pink; */
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/personalInfo/TrackSetting.vue